import { render, staticRenderFns } from "./userManualLottery.vue?vue&type=template&id=8b3ff998&"
import script from "./userManualLottery.vue?vue&type=script&lang=js&"
export * from "./userManualLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports